import React from 'react';
import styled from '@emotion/styled';
import { Global, css } from '@emotion/react';

// Academic Theme Colors
const theme = {
    colors: {
        primary: '#002147', // Oxford Blue
        secondary: '#005f73', // Teal/Dark Cyan
        accent: '#e9c46a', // Gold/Sand (for subtle highlights)
        background: '#ffffff',
        surface: '#f8f9fa', // Light Grey for sections
        text: {
            main: '#1a1a1a',
            secondary: '#4a4a4a',
            light: '#ffffff'
        },
        border: '#e0e0e0'
    },
    fonts: {
        heading: "'Merriweather', 'Playfair Display', serif",
        body: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }
};

const GlobalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700;900&family=Inter:wght@300;400;500;600;700&display=swap');

  body {
    font-family: ${theme.fonts.body};
    color: ${theme.colors.text.main};
    background-color: ${theme.colors.background};
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    color: ${theme.colors.primary};
  }
`;

const LayoutContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
`;

interface EducationLayoutProps {
    children: React.ReactNode;
}

export const EducationLayout: React.FC<EducationLayoutProps> = ({ children }) => {
    return (
        <LayoutContainer>
            <Global styles={GlobalStyles} />
            <Main>{children}</Main>
        </LayoutContainer>
    );
};

export default EducationLayout;
